// Import Redux Toolkit
import { configureStore } from "@reduxjs/toolkit";

// Import slices
import userReducer from "./slices/userSlice";
import profileReducer from "./slices/profileSlice";
import forgotPasswordReducer from "./slices/forgotPasswordSlice";
import allUsersReducer from "./slices/allUsersSlice";
import userDetailsReducer from "./slices/userDetailsSlice";
import roleReducer from "./slices/roleSlice";
import contactReducer from "./slices/contactSlice";
import productReducer from "./slices/productSlice";
import partyReducer from "./slices/partySlice";
import businessReducer from "./slices/businessSlice";
import billReducer from "./slices/billSlice";
import qrReducer from "./slices/qrSlice";
// Configure Redux store with Redux Toolkit
const store = configureStore({
  reducer: {
    user: userReducer,
    profile: profileReducer,
    forgotPassword: forgotPasswordReducer,
    allUsers: allUsersReducer,
    userDetails: userDetailsReducer,
    role: roleReducer,
    contact: contactReducer,
    product: productReducer,
    party: partyReducer,
    business: businessReducer,
    bill: billReducer,
    qr: qrReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
